const formatDateToUTC = (dateToFormat) => {
    if (dateToFormat === null) return "";
    const [year, month, day] = dateToFormat.split("T")[0].split("-");

    const newDate = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );

    return new Intl.DateTimeFormat("es-Es", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    }).format(new Date(newDate));
  };

export default formatDateToUTC;